import ArrowRight from 'plaid-threads/Icons/ArrowRight';
import React from 'react';
import { useRouter } from 'next/router';

import Layout from '../Layout';
import Image from '../Image';
import MarkdownIconButton from '../Header/MarkdownIconButton';

import styles from './Header.module.scss';

interface Props {
  product: string;
  assets: Array<{
    title?: string;
    src: string;
    width?: string;
    height?: string;
  }>;
  children: React.ReactNode;
}

const Header: React.FC<Props> = (props: Props) => {
  return (
    <Layout.Header>
      <div className={styles.wrapper}>
        <div className={styles.hero}>
          <div className={styles.titleWithIcon}>
            <h1 className={styles.title}>
              <span className={styles.titleInnerText}>Introduction to </span>
              {props.product}{' '}
            </h1>
            <MarkdownIconButton />
          </div>
          <h4 className={styles.subtitle}>{props.children}</h4>
        </div>
        {props.assets && (
          <div className={styles.assetColumn}>
            {props.assets.map((a, idx) => (
              <React.Fragment key={idx}>
                <div className={styles.asset}>
                  <Image
                    className={styles.assetImg}
                    alt={a.title}
                    src={a.src}
                    width={a.width}
                    height={a.height}
                  />
                  <label className={styles.assetLabel}>{a.title}</label>
                </div>
                {idx != props.assets.length - 1 && (
                  <ArrowRight className={styles.assetSeparator} />
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </Layout.Header>
  );
};

Header.displayName = 'Header';

export default Header;
